module.exports = __webpack_public_path__ + "img/xzl.2f583d6a.jpg";